<script>
import {mapGetters, mapActions} from 'vuex';

import {FORM_DATA_VALUES} from '@/modules/constants';
import DatePicker from '@/components/datepicker/DatePicker.vue';
import {textShortener} from '@/libs/utils';
import Tooltip from '@/modules/first-form/components/tooltip/Tooltip.vue';
import {getEuropeanDate} from '../../libs/utils';
import appConfig from '@/configs/app.config';
import FormSponsorTexts from "@/modules/first-form/components/FormSponsorTexts.vue";

const DEFAULT_STANDARD_LENGTH = 'Länge in m';
const DEFAULT_REASON = 'Privatumzug';
const FORM_ERRORS = {
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  ZIP: 'zip',
  LENGTH: 'length'
};

export default {
  name: 'FirstStepNewBg',

  components: {Tooltip, DatePicker, FormSponsorTexts},
  data() {
    return {
      FORM_DATA_VALUES,
      isMobile: false,
      moreAs25Meter: false,
      hideForm: true,
      formError: null,
      showReasonTooltip: false,
      formData: {
        zipCode: '',
        reason: '',
        length: '',
        dateFrom: '',
        dateTo: '',
        street: '',
        streetNr: '',
        timeStart: '',
        timeEnd: '',
        secondFormEnabled: false
      },
      formDataState: {
        zipCode: '',
        reason: DEFAULT_REASON,
        length: DEFAULT_STANDARD_LENGTH,
        dateFrom: '',
        dateTo: ''
      },
      isFormValid: false,
      variant: -1,
      mobilButtonValue:'Jetzt Preis berechnen'
    };
  },
  computed: {
    ...mapGetters(['priceInfo', 'priceNotExists', 'step', 'customer', 'reasonOptions', 'selectionPopup']),
    zipCodePlaceHolder: function() {
      //In welcher PLZ brauchen Sie die Zone?
      return this.isMobile && window.innerWidth < 761 ? 'PLZ' : 'PLZ';
    },

    renderLengthValue() {
      if (this.customer && this.customer.bsr) {
        return this.formDataState.length === DEFAULT_STANDARD_LENGTH
          ? DEFAULT_STANDARD_LENGTH
          : this.formDataState.length + ' Meter';
      }

      return this.formDataState.length === DEFAULT_STANDARD_LENGTH
        ? DEFAULT_STANDARD_LENGTH
        : this.formDataState.length + ' Meter';
    }
  },
  mounted() {
    if (window.innerWidth > 760) {
      this.hideForm = false;
    }
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('variant')) {
      //console.log(urlParams.get('variant'));
      this.variant = parseInt(urlParams.get('variant'));
    }

    if (this.customer && this.customer.bsr) {
      this.formDataState.reason = 'BSR-Gullyreinigung';
    }
    if (this.$root.$el.classList.contains("inline-form1")) {
      this.mobilButtonValue = "Jetzt Preis ermitteln & bestellen";
    }
  },
  updated() {
    this.isMobile = this.$store.getters.isMobile;
    this.moreAs25Meter = this.formData.length === FORM_DATA_VALUES.LONGER_THAN_25_METERS;
    if (this.priceInfo && this.formDataState.length === DEFAULT_STANDARD_LENGTH) {
      if (this.customer && this.customer.bsr) {
        this.formDataState.length = 20;
      }else {
        this.formDataState.length = this.priceInfo.standard_laenge
          ? this.priceInfo.standard_laenge[0]
          : DEFAULT_STANDARD_LENGTH;
      }
    }
    if (
      this.priceInfo &&
      this.formDataState.zipCode !== '' &&
      this.formDataState.dateTo &&
      this.formDataState.dateFrom &&
      this.formDataState.reason !== 'Dreharbeiten'
    ) {
      this.isFormValid = true;
    }
    if (this.formDataState.reason === 'Dreharbeiten') {
      this.showReasonTooltip = true;
      this.isFormValid = false;
    }
  },
  methods: {
    ...mapActions([
      'getPriceInfoAction',
      'setExistsPriceAction',
      'setFormDataAction',
      'resetPriceInfoAction',
      'setIsFormDetailsEditAction'
    ]),

    onFormChange: function() {
      this.$store.commit('SET_SELECTION_POPUP_ZIPID', null);
      this.$store.commit('SET_SELECTION_POPUP_LEVEL', 1);

      if (this.formDataState.zipCode.length === 5) {
        this.resetPriceInfoAction();
        this.formDataState.length = DEFAULT_STANDARD_LENGTH;

        this.getPriceInfoAction({ zipcode: this.formDataState.zipCode, priceForSecondForm: false });
      } else {
        this.isFormValid = false;
        if (this.priceInfo) {
          this.resetPriceInfoAction();
          this.formDataState.length = DEFAULT_STANDARD_LENGTH;
        }

        this.moreAs25Meter = false;

        this.formError = this.formError === FORM_ERRORS.ZIP ? null : this.formError;
        this.setExistsPriceAction(false);
      }
    },

    onFormSubmit: function() {
      if (!this.formDataState.zipCode) {
        this.formError = FORM_ERRORS.ZIP;
        return;
      }

      if (!this.formDataState.dateFrom) {
        this.formError = FORM_ERRORS.DATE_FROM;
        return;
      }

      if (!this.formDataState.dateTo) {
        this.formError = FORM_ERRORS.DATE_TO;
        return;
      }

      let dateFrom = this.formDataState.dateFrom.split(".");
      let dateObjFrom = new Date(dateFrom[2], dateFrom[1] - 1, dateFrom[0]);
      let dateTo = this.formDataState.dateTo.split(".");
      let dateObjTo = new Date(dateTo[2], dateTo[1] - 1, dateTo[0]);
      if (dateObjTo < dateObjFrom) {
        this.formError = FORM_ERRORS.DATE_TO;
        return;
      }

      if (this.formDataState.length === DEFAULT_STANDARD_LENGTH) {
        this.formDataState.length = this.priceInfo.standard_laenge[0];
      }
      if (this.formDataState.reason === 'Dreharbeiten') {
        return;
      }

      if (Number(this.variant) === 1) {
        //console.log('formDataState: ', this.formDataState);
        let link = appConfig.redirectUrl + `?plz=${this.formDataState.zipCode}&dateFrom=${this.formDataState.dateFrom}`+
        `&dateTo=${this.formDataState.dateTo}&length=${this.formDataState.length}&reason=${this.formDataState.reason}`
        window.open(link, '_blank')
        return;
      }
      this.$store.commit('SET_FORM_DATA', this.formDataState);
      this.setIsFormDetailsEditAction(false);

      setTimeout(() => this.$store.commit('SET_NEXT_STEP', 2), 100);
      //this.$store.commit('SET_NEXT_STEP', 2);
    },

    onDateSelect: function (date, name) {
      if (date.includes('/')) {
        date = getEuropeanDate(date);
      }

      this.formDataState[name] = date;

      if ((name === 'dateFrom') && !this.formDataState.dateTo) {
        this.formDataState.dateTo = date;
      }
      let from = this.formDataState.dateFrom.split(".");
      let to = this.formDataState.dateTo.split(".");

      // Check if dateTo is past of dateFrom
      if (this.formDataState.dateTo && this.formDataState.dateFrom) {
        let dateObjFrom = new Date(from[2], from[1] - 1, from[0]);
        let dateObjTo = new Date(to[2], to[1] - 1, to[0]);

        if (dateObjTo < dateObjFrom) {
          this.formDataState.dateTo = '';
          alert('Das Enddatum darf nicht in der Vergangenheit liegen. Bitte geben Sie ein korrektes Datum an.');
          this.formError = FORM_ERRORS.DATE_TO;
        }
      }
    },

    onDateFieldClick: function () {
      if (this.formDataState.dateTo < this.formDataState.dateFrom) {
        this.formDataState.dateTo = this.formDataState.dateFrom;
      }
      this.setExistsPriceAction(false);
    },

    onDateShow: function () {
      this.formError = null;
    },

    hidePopups: function () {
      this.formDataState.reason = DEFAULT_REASON;
      this.showReasonTooltip = false;
    },
    // imported helpers
    textShortener,
    toggle25meter: function (state) {
      this.formData.length = DEFAULT_STANDARD_LENGTH;
      if (state) {
        this.formData.length = FORM_DATA_VALUES.LONGER_THAN_25_METERS;
      }
      this.moreAs25Meter = state;
    },
    focusOnPlz: function () {
      this.hideForm = false;
      this.$nextTick(() => {
        if (this.$refs.plz) this.$refs.plz.focus();
        window.scrollTo(0, -100);
      });
    }
  }
};
</script>

<template>
  <div class="inline-first-page">
    <div v-if="Number(this.variant) === 1" class="form-container inline-form-wrapper">
      <div class="form-content">
        <h3 class="form-head">
          Was kostet eine Halteverbotszone in meiner Stadt?
        </h3>
        <div class="mb-xs-10 text-right" style="cursor: pointer">
          <i
            @click="
              hideForm = true;
              formDataState.zipCode = '';
            "
            class="fa fa-times visible-xs mobile-close-modal pr-xs-10"
          />
        </div>
        <div class="form-inputs">
          <div class="form-input-item field-zip-code">
            <input
              ref="plz"
              required
              class="zip-code"
              maxlength="5"
              type="text"
              :placeholder="zipCodePlaceHolder"
              value=""
              @input="onFormChange"
              v-model="formDataState.zipCode"
              data-toggle="popover"
              data-content=""
              title=""
              data-trigger="manual"
              data-placement="bottom"
              data-html="true"
              data-original-title=""
            />
            <div style="position:relative;">
              <tooltip :visible="priceNotExists" :variant="Number(this.variant)"/>
              <tooltip :visible="formError === 'zip'" :variant="Number(this.variant)" :is-error="true" text="Füllen Sie dieses Feld aus."/>
            </div>
          </div>

          <div class="date-fields-item">
            <date-picker
              input-id="datepicker-from"
              name="dateFrom"
              :value="formDataState.dateFrom"
              place-holder="Datum Von"
              :show="formError === 'dateFrom'"
              :on-select="onDateFieldClick"
              @onDateSelected="onDateSelect"
              @onDateShow="onDateShow"
            />
          </div>
          <div class="date-fields-item">
            <date-picker
              :show="formError === 'dateTo'"
              input-id="datepicker-to"
              name="dateTo"
              :value="formDataState.dateTo"
              place-holder="Datum Bis"
              :on-select="onDateFieldClick"
              @onDateSelected="onDateSelect"
              @onDateShow="onDateShow"
            />
          </div>

          <div class="dropdown">
            <button
              :disabled="!this.priceInfo || !this.priceInfo.standard_laenge"
              @click="toggle25meter(false)"
              class="btn btn-default dropdown-toggle text-left"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              {{ renderLengthValue }}
              <span class="fa fa-chevron-down"/>
            </button>

            <ul class="dropdown-menu" aria-labelledby="form-reason">
              <template v-if="priceInfo">
                <li v-for="length in priceInfo.standard_laenge" :key="length">
                  <a @click="formDataState.length = length" href="javascript:void(0)"> {{ length }} Meter </a>
                </li>
                <li>
                  <a @click="toggle25meter(true)" href="javascript:void(0)">
                    Mehr als 25 Meter
                  </a>
                </li>
              </template>
            </ul>
            <div style="position: relative;">
              <tooltip
                :visible="moreAs25Meter"
                text="Für eine Länge von mehr als 25 Metern müssen wir Ihnen ein gesondertes Angebot erstellen. Erfragen Sie Ihren Preis über unser"
              />
            </div>
          </div>

          <div
            class="dropdown reason-dropdown"
            data-toggle="popover"
            data-content=""
            title=""
            data-trigger="manual"
            data-placement="bottom"
            data-html="true"
            data-original-title=""
          >
            <button
              class="btn btn-default dropdown-toggle text-left"
              @click="hidePopups"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              {{ textShortener(formDataState.reason, 16) }}
              <span class="fa fa-chevron-down"/>
            </button>
            <ul class="dropdown-menu" aria-labelledby="form-length">
              <li v-for="reason in this.reasonOptions" :key="reason">
                <a @click="formDataState.reason = reason" href="javascript:void(0)">
                  {{ reason }}
                </a>
              </li>
            </ul>
            <div style="position: relative;">
              <tooltip
                :visible="showReasonTooltip"
                text="Bei Dreharbeiten müssen wir Ihnen ein gesondertes Angebot erstellen. Erfragen Sie Ihren Preis über unser "
              />
            </div>
          </div>
          <div class="form-input-item submit-btn">
            <input
              v-if="isFormValid"
              :disabled="moreAs25Meter || this.priceNotExists"
              type="submit"
              value="Preis berechnen"
              class="form-button"
              @click="onFormSubmit"
            />
            <input
              v-else
              :disabled="moreAs25Meter || this.priceNotExists"
              type="submit"
              class="form-button invalid"
              value="Preis berechnen"
              @click="onFormSubmit"
            />
          </div>
        </div>
      </div>
      <div class="break-flex"></div>
      <form-sponsor-texts :variant="this.variant" />
    </div>

    <div v-else class="first-step" style="position:relative;">
      <img class="custom-badge" style="position:absolute;top: 30px;right:30px;width: 150px;" alt="deutschlandweit" src="/templates/standard/files/images/landingpage/Halteverbot_Landing_Badge.png">
      <div class="container">
        <div class="heading" style="text-align: center !important; margin-bottom: 30px; position:relative;">
          <h2>
            <span class="head2" style="padding-top: 30px; text-align: center !important;">Du brauchst kein...</span>
          </h2>
          <div v-if="!this.$store.getters.isMobile">
            <img style="max-width: 400px !important;" src="/templates/standard/files/images/char-1.png" />
          </div>
          <div v-else>
            <img style="max-width: 220px;" src="/templates/standard/files/images/char-2.png" />
          </div>
          <h2>
            <span class="head2" style="padding-top: 10px; text-align: center !important;">um dir einen Platz freizuhalten</span>
          </h2>
          <h2>
            <span class="head2" style="padding-top: 20px; margin-bottom: 0px; text-align: center !important;">...Du brauchst Halteverbot123!</span>
          </h2>
        </div>
        <div v-if="hideForm"></div>

        <div class="row" v-else>
          <div class="form-container col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2" :style="!this.$store.getters.isMobile ? {marginTop: '15px !important'} : {marginTop: '78px !important'}">
            <h3 v-if="customer && (customer.bsr || customer.kuchenaktuell)" class="form-head mt-0 mb-0"><br /></h3>
            <h3 v-else class="form-head">Was kostet eine Halteverbotszone in meiner Stadt?</h3>
            <div class="mb-xs-10 text-right" style="cursor: pointer">
              <i
                @click="
                  hideForm = true;
                  formDataState.zipCode = '';
                "
                class="fa fa-times visible-xs mobile-close-modal pr-xs-10"
              />
            </div>
            <div class="form-inputs">
              <div class="form-input-item field-zip-code">
                <input
                  ref="plz"
                  required
                  class="zip-code"
                  maxlength="5"
                  type="text"
                  pattern="\d*"
                  :placeholder="zipCodePlaceHolder"
                  value=""
                  @input="onFormChange"
                  v-model="formDataState.zipCode"
                  data-toggle="popover"
                  data-content=""
                  title=""
                  data-trigger="manual"
                  data-placement="bottom"
                  data-html="true"
                  data-original-title=""
                />
                <div style="position:relative;">
                  <tooltip :visible="priceNotExists"/>
                  <tooltip :visible="formError === 'zip'" :is-error="true" text="Füllen Sie dieses Feld aus."/>
                </div>
              </div>

              <div class="form-input-item date-fields">
                <div class="date-fields-item">
                  <date-picker
                    input-id="datepicker-from"
                    name="dateFrom"
                    :value="formDataState.dateFrom"
                    place-holder="Datum Von"
                    :show="formError === 'dateFrom'"
                    :on-select="onDateFieldClick"
                    @onDateSelected="onDateSelect"
                    @onDateShow="onDateShow"
                  />
                </div>
                <div class="date-fields-item">
                  <date-picker
                    :show="formError === 'dateTo'"
                    input-id="datepicker-to"
                    name="dateTo"
                    :value="formDataState.dateTo"
                    place-holder="Datum Bis"
                    :on-select="onDateFieldClick"
                    @onDateSelected="onDateSelect"
                    @onDateShow="onDateShow"
                  />
                </div>
              </div>

              <div class="form-input-item dropdown-list">
                <div class="dropdown">
                  <button
                    :disabled="!this.priceInfo || !this.priceInfo.standard_laenge"
                    @click="toggle25meter(false)"
                    class="btn btn-default dropdown-toggle text-left"
                    type="button"
                    id="form-reason"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                  >
                    {{ renderLengthValue }}
                    <span class="fa fa-chevron-down"/>
                  </button>

                  <ul class="dropdown-menu" aria-labelledby="form-reason">
                    <template v-if="priceInfo && customer && customer.bsr">
                      <li>
                        <a @click="formDataState.length = 20" href="javascript:void(0)"> 20 Meter </a>
                        <a @click="formDataState.length = 40" href="javascript:void(0)"> 40 Meter </a>
                        <a @click="formDataState.length = 60" href="javascript:void(0)"> 60 Meter </a>
                        <a @click="formDataState.length = 80" href="javascript:void(0)"> 80 Meter </a>
                        <a @click="formDataState.length = 100" href="javascript:void(0)"> 100 Meter </a>
                      </li>
                    </template>

                    <template v-else-if="priceInfo">
                      <li v-for="length in priceInfo.standard_laenge" :key="length">
                        <a @click="formDataState.length = length" href="javascript:void(0)"> {{ length }} Meter </a>
                      </li>
                      <li>
                        <a @click="toggle25meter(true)" href="javascript:void(0)">
                          Mehr als 25 Meter
                        </a>
                      </li>
                    </template>
                  </ul>
                  <div style="position: relative;">
                    <tooltip
                      :visible="moreAs25Meter"
                      text="Für eine Länge von mehr als 25 Metern müssen wir Ihnen ein gesondertes Angebot erstellen. Erfragen Sie Ihren Preis über unser"
                    />
                  </div>
                </div>

                <div
                  class="dropdown"
                  data-toggle="popover"
                  data-content=""
                  title=""
                  data-trigger="manual"
                  data-placement="bottom"
                  data-html="true"
                  data-original-title=""
                >
                  <button
                    class="btn btn-default dropdown-toggle text-left"
                    @click="hidePopups"
                    type="button"
                    id="form-length"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                  >
                    {{ textShortener(formDataState.reason, 16) }}
                    <span class="fa fa-chevron-down"/>
                  </button>

                  <ul class="dropdown-menu" aria-labelledby="form-length">
                    <li v-if="customer && customer.bsr">
                      <a @click="formDataState.reason = 'BSR-Gullyreinigung'" href="javascript:void(0)">BSR-Gullyreinigung</a>
                    </li>

                    <li v-for="reason in this.reasonOptions" :key="reason">
                      <a @click="formDataState.reason = reason" href="javascript:void(0)">
                        {{ reason }}
                      </a>
                    </li>
                  </ul>
                  <div style="position: relative">
                    <tooltip
                      :visible="showReasonTooltip"
                      text="Bei Dreharbeiten müssen wir Ihnen ein gesondertes Angebot erstellen. Erfragen Sie Ihren Preis über unser "
                    />
                  </div>
                </div>
              </div>

              <div class="form-input-item submit-btn">
                <input
                  v-if="isFormValid"
                  :disabled="moreAs25Meter || this.priceNotExists"
                  type="submit"
                  value="Preis berechnen"
                  class="form-button"
                  @click="onFormSubmit"
                />
                <input
                  v-else
                  :disabled="moreAs25Meter || this.priceNotExists"
                  type="submit"
                  class="form-button invalid"
                  value="Preis berechnen"
                  @click="onFormSubmit"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.variant !== 2 && this.$store.getters.isMobile">
        <div class="mobile_zip_code_container bgcolor-remove zipcode-padding" v-if="this.$store.getters.isMobile && hideForm">
        <button
          id="mobile-zip-code-input"
          type="button"
          class="mobile-zip-code-input btn-new"
          v-on:click="() => focusOnPlz()"
        >
          {{ mobilButtonValue }}
        </button>
      </div>
    </div>
  </div>
</template>

<!-- css for component styles -->
<style scoped lang="scss">
@import 'FirstFormNewBgStyles';
</style>

<!-- css for global styles -->
<style lang="scss"></style>
